import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '../../environments/environment';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class SuppliesService {
  constructor(private http: HttpClient) { }

  getSuppliesRequests(page: any, warehouse_id: number): Observable<any> {
    return this.http.get(
      `${environment.Server_URL}/supplies?page=${page}&warehouse_id=${warehouse_id}`
    );
  }
  getStatementByPhone(phone: string): Observable<any> {
    return this.http.get(
      `${environment.Server_URL}/client-statements/by-phone`,
      {
        params: { phone }
      }
    );
  }

  supplyRequest(formData: FormData): Observable<any> {
    return this.http.post(`${environment.Server_URL}/supplies`, formData);
  }
  deleteSupplyRequest(id: string): Observable<any> {
    return this.http.delete(`${environment.Server_URL}/supplies/${id}`);
  }
  acceptSupplyRequest(id: any, bool: any, adminId: any): Observable<any> {
    const body = new FormData();
    body.append('accepted_by', adminId);
    if (bool)
      body.append('status', "accepted");
    else
      body.append('status', "rejected");
    return this.http.post(`${environment.Server_URL}/supplies/${id}/accept`, body);
  }
  updateStockAfterAccept(id: any, productsIds: any, qtys: any, prices: boolean): Observable<any> {
    const body = {
      ids: productsIds,
      quantity: qtys,
      price: prices,
      supply_id: id
    };
    return this.http.post(`${environment.Server_URL}/update-stocks`, body);
  }
  changeCreditValues(id: any, payed: any, notpayed: any): Observable<any> {
    const body = new FormData();
    body.append('not_payed', notpayed);
    body.append('payed', payed);
    return this.http.post(`${environment.Server_URL}/supplies/${id}/payment`, body);
  }
  changeInstalimentValues(id: any, installment_price: any, installment_period: any): Observable<any> {
    const body = new FormData();
    body.append('installment_price', installment_price);
    body.append('installment_period', installment_period);
    return this.http.post(`${environment.Server_URL}/supplies/${id}/update/Installment`, body);
  }
  createManualAdjustment(
    phone: string,
    amount: number,         // موجب أو سالب حسب ما هتتعامل في الباك إند
    warehouse_id: any
  ): Observable<any> {
    const body: any = {
      phone,
      amount,
      warehouse_id
    };



    return this.http.post(
      `${environment.Server_URL}/client-statements/manual-adjustment`,
      body
    );
  }
  getSupplyById(id: number | string): Observable<any> {
    return this.http.get(`${environment.Server_URL}/supplies/${id}`);
  }

}
